import styled from 'styled-components';
import { Banner, StyledFlex } from '@tryhackme/thm-ui-components';

export const StyledBanner = styled(Banner)`
  height: 38rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: auto;
  }
`;

export const StyledBannerContent = styled.div`
  align-content: flex-end;
  align-items: flex-end;
  display: flex;
  flex-wrap: nowrap;
  height: 38rem;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    flex-direction: column;
    height: auto;
  }

  & > div {
    align-self: center;
    flex-basis: 60%;

    @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
      flex-basis: auto;
      margin: 8rem 0 10rem;
    }

    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      margin: 4.6rem 0 7.6rem;
    }

    h1::first-letter {
      text-transform: uppercase;
    }

    span {
      color: ${({ theme }) => theme.colors.primary.main};
      display: inline-block;
    }
  }

  svg {
    height: 29rem;
    width: auto;
  }
`;

export const StyledFiltersWrapper = styled(StyledFlex)`
  align-items: center;
  margin: 4.6rem 0;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: column-reverse;
    margin: 3rem 0 4.6rem;
  }

  svg {
    fill: ${({ theme }) => theme.colors.grey[700]};
    height: 1.6rem;
    width: auto;
  }

  & > div {
    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      max-width: -webkit-fill-available;
    }
  }
`;

export const StyledSearch = styled.div`
  max-width: 40rem;
  width: 40rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }
`;

export const StyledCardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 4.6rem 0 8rem;

  p {
    font-size: 2rem;
  }
`;

export const StyledButtonWrapper = styled(StyledFlex)`
  justify-content: center;
  margin-top: 4.6rem;
`;

export const StyledResourcesPage = styled.section`
  padding-bottom: 8rem;
`;
